// extracted by mini-css-extract-plugin
export default {"Academy":"sixYardAcademy_Academy__gx2wk","DarkEffect":"sixYardAcademy_DarkEffect__Rb43i","Background":"sixYardAcademy_Background__IE7ps"};